import { fetchEntries, fetchOneEntry } from '@builder.io/sdk-vue';
import { EcomService } from "~/services/ecom.service";
import {generateKeyFromObject} from "../utils/string";

export class BuilderService {


    private api_key: string;

    constructor(api_key: string) {
        this.api_key = api_key;
    }

    async getList(
        model = 'pages', query = {},
        sort = {}, limit = 10, offset = 0,
        nuxtApp: any = null, redisCacheBurst = false
    ) {

        let locale = 'nl-NL'
        if(nuxtApp && nuxtApp.$i18n){
            const i18n = { global: nuxtApp.$i18n };
            locale: i18n.global.locale.value
        }

        let apiKey = this.api_key;

        let options  = {
            locale,
            model,
            apiKey,
            query,
            sort,
            limit,
            offset,
            userAttributes: { locale: undefined }
        }

        let key = model+'-'+await generateKeyFromObject(options);
        if(nuxtApp && nuxtApp.$redis && !redisCacheBurst){
            const data = await EcomService.getRedisDataByKey(nuxtApp.$redis,key);

            if(data){
                return JSON.parse(data);
            }
        }

        try {
            const response = await fetchEntries(options);

            if(nuxtApp && nuxtApp.$redis){
                nuxtApp.$redis.set(key,JSON.stringify(response), "EX", 200);
            }

            return response;
        } catch (error) {
            const {customClientErrorHandler} = await import("~/services-optimized/customErrorService");

            let errorMeta = {
                model,
                query,
                builderServiceError: true,
            }

            customClientErrorHandler(
                error,
                'high',
                'Builder Service Error - trying to fetch builder list using getList()',
                errorMeta
            );
            return error;
        }
    }

    async getItem(model = 'pages', userAttributes = {}, options = {}, query = {},
                  nuxtApp: any = null)
    {
        let apiKey = this.api_key;
        const i18n = { global: nuxtApp?nuxtApp.$i18n:null };
        const builderOptions = {
            locale: i18n?.global?.locale?.value,
            model,
            apiKey,
            query,
            userAttributes,
            options,
            cachebust: true,
            cacheSeconds: 0,
        };

        try {
            return await fetchOneEntry(builderOptions);
        } catch (error) {
            const {customClientErrorHandler} = await import("~/services-optimized/customErrorService");
            let errorMeta = {
                model,
                query,
                userAttributes,
                builderServiceError: true,
            }

            customClientErrorHandler(
                error,
                'high',
                'Builder Service Error - trying to fetch items using getItem()',
                errorMeta
            );
            return error;
        }
    }


    async getContentModel(model: string, apiKey: string) {
        return await useAjax(useRuntimeConfig().public.builderBaseUrl + model + `?apiKey=${apiKey}`,
            {
                headers: {
                    accept: "*/*"
                },
                show_notifications: false,
                show_loading_indicator: false
            }

        );
    }
}
